




























































































































































import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { Emit, Watch } from "vue-property-decorator";
import UserInterface from "@/types/app/IUser";
import CustomerAccount from "@/components/headers/customer-accounts";
import Header from "@/types/app/header";
import Account, { accountInitialValue } from "@/types/app/accounts";
import formatMoney from "@/utils/formatMoney";
import applyCondition from "@/utils/applyCondition";
import formatDate from "@/utils/formatDate";
import { truncate } from "@/utils/truncate";
import AccountService from "@/services/accountService";
import ModalNewAccount from "@/views/accounts/new.vue";
import Endpoint from "@/utils/endpoint";
import ErrorService from "@/services/erroService";
import BaseComponent from "@/utils/baseComponent";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import CustomerService from "@/services/customerService";
const namespace = "account";

@Component({
  components: {
    newAccount: ModalNewAccount,
  },
  methods: {
    formatMoney,
    formatDate,
    truncate,
  },
})
export default class AccountsIndex extends BaseComponent {
  @Getter("getModalNewAccountState", { namespace })
  modalNewAccountState!: boolean;

  @Action("setModaAccountState", { namespace })
  setModalAccountState!: any;
  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;
  @Action("setModalAccountGroupingState", { namespace })
  setModalAccountGroupingState!: (modalIsVisible: boolean) => void;
  @Action("setModalNewAccountState", { namespace })
  setModalNewAccountState!: (modalIsVisible: boolean) => void;

  @Action("setAccountState", { namespace })
  setAccountState!: (account: Account) => void;
  //@Getter("getCustomers", { namespace: 'customer' }) customers!: Customer[];
  customerService = new CustomerService(this.$http);
  private accountService = new AccountService(this.$http);
  private endpoint = new Endpoint();
  loadingAccounts = false;
  headers: Header[] = CustomerAccount.header;
  selectedAccounts: any[] = [];
  listAccountInvestor: VuetifySelectItems[] = []
  investorNameFilter = "";
  accountNumberFilter = "";
  returnedInWalletFilter = "";
  fundNameFilter = "";
  emailFilter = "";
  accounts: Account[] = [];

  @Watch("modalNewAccountState")
  async refreshAccounts(newValue: boolean) {
    if (newValue) {
      return;
    }
    await this.handleAccounts();
  }

  async copyData(item:Account) {
    try {
      const result = { 
                userId: item.userId, 
                fundId: item.fundId, 
                accountNumber: item.accountNumber,
                email: item.email, 
                investor: item.investorName,
                fundName: item.fundName,                
                }
      await navigator.clipboard.writeText(JSON.stringify(result));
      this.showSuccess('Copied data to clipboard');
    } catch($e) {
      alert('Cannot copy');
    }
  }

  async mounted() {
    await this.handleAccounts();

  }

  async handleAccounts() {
    const t0 = performance.now();

    try {
      this.loadingAccounts = true;
      const [newAccounts, taskResult2] = await Promise.all([this.accountService.getAccounts(),
      this.customerService.getSelectAccountCustomers()])
      this.accounts = newAccounts;
      this.listAccountInvestor = taskResult2;
      this.accounts.forEach(a => {
        const investor = this.listAccountInvestor.find(x => x.value == a.userId);
        a.investorName = investor?.name || `Not found(${a.userId})`;
        a.email = investor?.email || `Not found(${a.userId})`;
      });

    } catch (error) {
      ErrorService.onError(error);
    } finally {
      this.loadingAccounts = false;
      const t1 = performance.now();
      ErrorService.sentryTraceInfo('handleAccounts', t1 - t0);
    }
  }


  get filteredAccounts() {
    const conditions: any[] = [];
    if (this.investorNameFilter) {
      conditions.push((item: Account) =>
        item.investorName?.toLowerCase()?.includes(this.investorNameFilter.toLowerCase())
      );
    }

    if (this.accountNumberFilter) {
      conditions.push((item: Account) =>
        item.accountNumber
          ?.toLowerCase()
          ?.includes(this.accountNumberFilter.toLowerCase())
      );
    }

    if (this.fundNameFilter) {
      conditions.push((item: Account) =>
        item.fundName
          ?.toString()
          ?.toLowerCase()
          ?.includes(this.fundNameFilter.toLowerCase())
      );
    }

    if (this.emailFilter) {
      conditions.push((item: Account) =>
        item.email?.toString()?.toLowerCase()?.includes(this.emailFilter.toLowerCase())
      );
    }

    if (this.returnedInWalletFilter && this.returnedInWalletFilter.length > 0) {
      conditions.push((item: Account) =>
        item.returnedInWallet
          .toString()
          .toLowerCase()
          .includes(this.returnedInWalletFilter.toLowerCase())
      );
    }

    return applyCondition<Account>(this.accounts, conditions);
  }

  showAccount(account: Account) {
    this.setAccountState(account);
    this.setModalNewAccountState(true);
  }

  get hasSelectToDelete() {
    return this.selectedAccounts.length > 0;
  }

  async deleteAccount() {
    this.$confirm("Do you really want to delete these accounts?").then((res) => {
      if (res) {
        const url = this.endpoint.account;
        this.loadingAccounts = true;
        this.$http
          .delete(`${url}`, {
            data: { usersAccountId: this.selectedAccounts.map((x) => x.id) },
          })
          .then(async (res: any) => {
            this.showSuccess("Deleted user account(s) with success!");
          })
          .catch(async (err) => {
            ErrorService.onError(err);
          })
          .finally(async () => {
            this.selectedAccounts = [];
            await this.handleAccounts();
            this.loadingAccounts = false;
          });
      }
    });
  }

  showNewAccountModal() {
    this.setAccountState(accountInitialValue);
    this.setModalNewAccountState(true);
  }

  async exportCsv(onGrid = false) {

    let newArr = this.accounts.sort(
      (a, b) => new Date(a.entryDateTime).getTime() - new Date(b.entryDateTime).getTime()
    );
    if (onGrid) {
      newArr = this.filteredAccounts;
    }
    this.exportCSVFile([...newArr], `Account-export${onGrid ? '-WithFilter' : '-All'}`);
  }

  // async exportCompanyTemplate() {
  //   try {
  //     const exportItems = this.customers.filter(c => c.isAccountManagerOld
  //         && !c.email.endsWith('@leste.com')).map(c =>
  //         c.oldFamilyMembers.map(f => ({
  //         CompanyAlreadyExist: 'N',
  //         CompanyName: c.fullName,
  //         CompanyEmail: c.email,
  //         IsClientUser: 'Y',
  //         InvestorAlreadyExist: 'N',
  //         InvestorName: f.name,
  //         InvestorEmail: f.email
  //       })).flatMap(x => x)
  //     ).flat();
  //     console.log('CompanyTemplate-export', exportItems);
  //     // this.exportCSVFile([...exportItems], `CompanyTemplate-export`);

  //     const nameTemplate = "Template-Companies";
  //     const dataInterestJson = XLSX.utils.json_to_sheet(exportItems, {
  //       header: [
  //         "CompanyAlreadyExist",
  //         "CompanyName",
  //         "CompanyEmail",
  //         "CompanyCountry",
  //         "InvestorAlreadyExist",
  //         "IsClientUser",
  //         "InvestorName",
  //         "InvestorEmail",
  //         "FundName",
  //         "AccountNumber"
  //       ],
  //     });
  //       const wbInterest = XLSX.utils.book_new();
  //       XLSX.utils.book_append_sheet(wbInterest, dataInterestJson, "BulkCompanies");
  //       XLSX.writeFile(wbInterest, nameTemplate + new Date().getTime() + ".xlsx");
      
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
}
